import React from 'react'
import { FontIcon } from 'react-md'

import { Checkbox } from 'components'

import './index.css'

const CheckboxInfo = ({ info, onInfoClick, ...rest }) => {
  return (
    <div className='checkbox-info-container'>
      <Checkbox {...rest} />
      <FontIcon
        className='checkbox-info-icon'
        forceSize={15}
        forceFontSize
        onClick={() => onInfoClick(info)}
      >
        info
      </FontIcon>
    </div>
  )
}

export default CheckboxInfo



// WEBPACK FOOTER //
// ./src/components/CheckboxInfo/index.js